export default __webpack_public_path__ + "static/media/backArrow.d79d62c4.svg";